var React = require('react');

function IconAccountInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"icon_account_inline","d":"M12.5 12c3.59 0 6.5 2.53 6.5 5.66s-13 3.12-13 0S8.91 12 12.5 12zM12 5a3 3 0 110 6 3 3 0 010-6z"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#icon_account_inline","transform":"translate(-6 -5)","fillRule":"evenodd","key":1})]);
}

IconAccountInline.defaultProps = {"viewBox":"0 0 13 15"};

module.exports = IconAccountInline;

IconAccountInline.default = IconAccountInline;
